/* RESPONSIBLE TEAM: team-frontend-tech */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'bound_web_events';
  },
});
